export const ESRI = 'esri';
export const GOOGLE = 'google';
